'use client'

import type { NavigationDesktopItemProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-header.types'

import classNames from 'classnames'

import { useNavigationDesktopItem } from '@maestro/commerce-blocks/components/navigation-header/batons/use-navigation-desktop-item'
import NavigationDesktopDropdown from '@maestro/commerce-blocks/components/navigation-header/navigation-desktop-dropdown'
import { Link } from '@pearlconvert/ui/components/link'

export default function NavigationDesktopItem(
  props: NavigationDesktopItemProps
) {
  const { node } = props
  const {
    isActive,
    itemRef,
    closeDropdown,
    handleBlur,
    handleClickLink,
    handleControlKeyDown,
    handleMouseEnter,
    handleMouseLeave,
    isDesktopView,
    isMegaDropdown,
  } = useNavigationDesktopItem(node)

  const submenuId = `${node.title?.toLowerCase().replace(/\s+/g, '-')}-submenu`
  const Tag = (node.children ? 'button' : Link) as React.ElementType

  return (
    <li
      ref={itemRef}
      role="none"
      className={classNames('nav-desktop__item', node.cssClass, {
        'nav-desktop__item--has-mega-dropdown': isMegaDropdown(node.depth),
      })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onBlur={(event) => handleBlur(event.relatedTarget)}
    >
      <Tag
        className={classNames('nav-desktop__link', {
          'nav-desktop__link--active': node.children && isActive,
          'nav-desktop__link--highlight': node.highlight,
        })}
        {...(Tag === Link && { href: node.url })}
        {...(Tag === Link && { target: node.target })}
        onClick={handleClickLink}
        onKeyDown={handleControlKeyDown}
        aria-expanded={node.children ? isActive : undefined}
        aria-controls={node.children ? submenuId : undefined}
        aria-haspopup={node.children ? 'true' : undefined}
      >
        {node.title}
      </Tag>
      {node.children && isDesktopView && (
        <NavigationDesktopDropdown
          node={node}
          title={node.title}
          nodes={node.children}
          isMegaDropdown={isMegaDropdown(node.depth)}
          isActive={isActive}
          closeDropdown={closeDropdown}
          submenuId={submenuId}
        />
      )}
    </li>
  )
}
